import { render, staticRenderFns } from "./RtlSupport.vue?vue&type=template&id=e5948aac&"
import script from "./RtlSupport.vue?vue&type=script&lang=js&"
export * from "./RtlSupport.vue?vue&type=script&lang=js&"
import style0 from "./RtlSupport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RtlSupport.vue"
export default component.exports